import { createInheritedProvider } from "@shapeable/utils";
import React from "react";
export var defaultSiteSearchConfig = {
  isVisible: false,
  isAvailable: true,
  extraDataHooks: {}
};
export var SiteSearchContext = React.createContext(defaultSiteSearchConfig);
export var SiteSearchProvider = createInheritedProvider(SiteSearchContext);